/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Error_Line_2Inputs */

const fr_vehicle_action_edit_error_line_2 = /** @type {(inputs: Vehicle_Action_Edit_Error_Line_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez la validité du jeton et vos droits d'édition.`)
};

const en_vehicle_action_edit_error_line_2 = /** @type {(inputs: Vehicle_Action_Edit_Error_Line_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check that the token is valid and that you have editing rights.`)
};

/**
* | output |
* | --- |
* | "Check that the token is valid and that you have editing rights." |
*
* @param {Vehicle_Action_Edit_Error_Line_2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_error_line_2 = /** @type {((inputs?: Vehicle_Action_Edit_Error_Line_2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Error_Line_2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_error_line_2(inputs)
	return en_vehicle_action_edit_error_line_2(inputs)
});